import * as React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { TextField } from "@mui/material";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/lab";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicDateTimePickerProps {
  showTime: boolean;
  value: Date;
  onChange: (dateVal: Date) => void;
  locale: string;
  disabled?: boolean;
  disablePast?: boolean;
  minDateMessage?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicDateTimePicker = ({
  ...props
}: ClinicDateTimePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={DateFnsUtils}>
      {props.showTime ? (
        <DateTimePicker
          renderInput={(props) => <TextField {...props} />}
          label="Select Date and Time"
          value={props.value ? new Date(props.value) : null}
          onChange={props.onChange}
          disablePast={props.disablePast}
          disabled={props.disabled}
        />
      ) : (
        <DatePicker
          renderInput={(props) => <TextField {...props} />}
          label="Select Date"
          value={props.value ? new Date(props.value) : null}
          onChange={props.onChange}
          disablePast={props.disablePast}
          disabled={props.disabled}
        />
      )}
    </LocalizationProvider>
  );
};
